import React from 'react';
import styled from 'styled-components';

const Card = styled.div`
  background: #1a1a1a;
  border: 1px solid #4c1d95;
  border-radius: 12px;
  padding: 20px;
`;

const Title = styled.h3`
  color: #a78bfa;
  font-size: 14px;
  font-weight: 700;
  margin: 0 0 16px 0;
  letter-spacing: 0.05em;
  text-transform: uppercase;
`;

const GuaHeader = styled.div`
  display: flex;
  align-items: baseline;
  gap: 12px;
  margin-bottom: 16px;
`;

const GuaName = styled.div`
  font-size: 32px;
  font-weight: 900;
  color: #e5e5e5;
`;

const GuaCn = styled.div`
  font-size: 22px;
  color: #a78bfa;
`;

const GuaEn = styled.div`
  font-size: 13px;
  color: #6b7280;
  margin-left: auto;
`;

const Body = styled.div`
  display: grid;
  grid-template-columns: auto 1fr;
  gap: 16px;
  align-items: start;
`;

const HexLines = styled.div`
  display: flex;
  flex-direction: column-reverse;
  gap: 5px;
  padding: 8px;
  background: #111;
  border-radius: 8px;
`;

const HexLine = styled.div`
  display: flex;
  gap: 4px;
  align-items: center;
  position: relative;
`;

const Bar = styled.div`
  height: 5px;
  border-radius: 2px;
  background: ${({ $yang, $changing }) =>
    $changing ? '#ef4444' : $yang ? '#f59e0b' : '#4b5563'};
  width: ${({ $yang }) => $yang ? '48px' : '20px'};
`;

const ChangingDot = styled.div`
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #ef4444;
  margin-left: 4px;
`;

const InfoArea = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

const InfoRow = styled.div``;

const InfoLabel = styled.div`
  color: #6b7280;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.05em;
  margin-bottom: 4px;
`;

const InfoText = styled.div`
  color: #d1d5db;
  font-size: 13px;
  line-height: 1.6;
`;

const ChangedGua = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: #1f1030;
  border: 1px solid #4c1d95;
  border-radius: 8px;
  padding: 6px 12px;
  color: #a78bfa;
  font-size: 13px;
`;

function HexagramVisual({ gua, changingLines }) {
  const binary = gua.binary; // 6 chars, index 0=1효(하), index 5=6효(상)
  return (
    <HexLines>
      {binary.split('').map((bit, i) => {
        const isYang = bit === '1';
        const isChanging = changingLines.includes(i + 1);
        return (
          <HexLine key={i}>
            {isYang ? (
              <Bar $yang $changing={isChanging} />
            ) : (
              <>
                <Bar $changing={isChanging} />
                <Bar $changing={isChanging} />
              </>
            )}
            {isChanging && <ChangingDot />}
          </HexLine>
        );
      })}
    </HexLines>
  );
}

export default function HexagramResult({ gua, changedGua, changingLines, activeLine }) {
  if (!gua) return null;

  return (
    <Card>
      <Title>Step 4 — 괘 결과</Title>
      <GuaHeader>
        <GuaCn>{gua.name.cn}</GuaCn>
        <GuaName>{gua.id}. {gua.name.ko}괘</GuaName>
        <GuaEn>{gua.name.en}</GuaEn>
      </GuaHeader>

      <Body>
        <HexagramVisual gua={gua} changingLines={changingLines} />
        <InfoArea>
          <InfoRow>
            <InfoLabel>괘사(卦辭)</InfoLabel>
            <InfoText>{gua.judgment}</InfoText>
          </InfoRow>
          {activeLine && (
            <InfoRow>
              <InfoLabel>변효(變爻)</InfoLabel>
              <InfoText>{activeLine}</InfoText>
            </InfoRow>
          )}
          {changedGua && (
            <InfoRow>
              <InfoLabel>지괘(之卦)</InfoLabel>
              <ChangedGua>
                {changedGua.name.cn} {changedGua.name.ko}괘로 변함
              </ChangedGua>
            </InfoRow>
          )}
        </InfoArea>
      </Body>
    </Card>
  );
}
